const lookupHistoryKeyPrefix = 'dmcLookupHistory_'
const maxLookupHistoryItems = 15

export function getLookupHistory(context) {
  const lookupHistory = localStorage.getItem(lookupHistoryKeyPrefix + context)
  return !lookupHistory ? [] : JSON.parse(lookupHistory).sort((a, b) => b.added - a.added)
}

const updateLookupHistory = (context, updatedLookupHistory) => {
  localStorage.setItem(lookupHistoryKeyPrefix + context, JSON.stringify(updatedLookupHistory))
}

/**
 * Stores a lookup history item, unless it is already present, in which case it
 * updates the added value of the item so it appears higher in the list.
 * @param context of the lookup
 * @param value being looked up
 * @return {Array} updated lookup history
 */
export function addToLookupHistory(context, value) {
  const lookupHistory = getLookupHistory(context)
  const matches = lookupHistory.filter((item) => item.value === value)
  if (matches.length === 0) {
    lookupHistory.unshift({
      value,
      added: Date.now(),
    })
    while (lookupHistory.length > maxLookupHistoryItems) {
      lookupHistory.pop()
    }
  } else {
    matches[0].added = Date.now()
  }
  updateLookupHistory(context, lookupHistory)
  return lookupHistory
}

/**
 * Allows a description (e.g. the name associated with an ID) to be added after
 * the data is retrieved, since that information is not always available to the
 * lookup component. Since not every resource is found using lookup, the
 * description will only be added if an item is found with a matching ID in the
 * history.
 * @param context
 * @param value
 * @param description
 */
export function addLookupHistoryItemDescription(context, value, description) {
  const lookupHistory = getLookupHistory(context)
  const matches = lookupHistory.filter((item) => item.value === value)
  if (matches.length !== 0) {
    matches[0].description = description
    updateLookupHistory(context, lookupHistory)
  }
}

/**
 * Removes a lookup history item from storage. Useful when the value being
 * looked up is not valid, not found, or any other case where it wouldn't be
 * useful to store the value in the history.
 * @param context
 * @param value
 */
export function removeFromLookupHistory(context, value) {
  const lookupHistory = getLookupHistory(context)
  updateLookupHistory(
    context,
    lookupHistory.filter((item) => {
      return item.value.toUpperCase() !== value.toUpperCase()
    })
  )
}
